export const CRAWL_STATUS = {
    started: 'started',
    queued: 'queued',
    backoff: 'backoff',
    retry: 'retry',
} as const;
